import { ChannelState } from '../../../enums/channel-state.enum';
import { ChannelActionItem } from '../../../store/models/channels';
import { CycleController } from '../../../store/models/controllers';
import { IoTDataResponse } from '../../../store/models/cycles';
import { IControllerSettings } from '../../../types/controller-types';
import getChannelNumByString from '../../../utils/getChannelNumByString';
import { channelStateToEnum } from '../../../utils/value-to-enum';

const getChannelActionItems = (
  cycleControllers: CycleController[],
  iotDataResponse: IoTDataResponse[],
  controllersSettings?: Record<string, IControllerSettings>,
): ChannelActionItem[] => {
  return cycleControllers.flatMap((cycleController) => {
    const { controller } = cycleController;
    const serialNumber = controller.serial_number;

    return cycleController.channels.flatMap((channelName) => {
      const iotChannel = iotDataResponse.find((iot) => iot.serial === serialNumber && iot.channel === channelName);

      if (!iotChannel?.channel) {
        return [];
      }

      const enumState = channelStateToEnum(iotChannel.state);
      const isManualFaulted = iotChannel.manualFault !== null && iotChannel.manualFault !== undefined;

      const controllerSettings = controllersSettings?.[serialNumber];
      const hasControllerFaults = controllerSettings?.faults?.value?.length > 0;
      const hasActualIoTFault = enumState === ChannelState.FAULTED || hasControllerFaults;

      if (!hasActualIoTFault && !isManualFaulted) {
        return [];
      }

      const channel_num = getChannelNumByString(iotChannel.channel);
      const manualFaultsOnly = isManualFaulted && !hasActualIoTFault;

      return {
        controller_serial_number: serialNumber,
        channel_num: String(channel_num),
        ...(manualFaultsOnly && { manualFaultsOnly: true }),
      };
    });
  });
};

export default getChannelActionItems;
